import { Typography } from "@hellocarbo/lasagne";
import { cn } from "@hellocarbo/lasagne/utils";
import { useTranslation } from "react-i18next";

import { TCarbonUnit } from "@/types";
import { formatCarbon } from "@/utils/carbon";

type CarbonIntensityProps = {
  title: string;
  value?: number;
  unit: string;
  emptyValueMessage: string;
};

function CarbonIntensity({
  title,
  value,
  unit,
  emptyValueMessage,
}: CarbonIntensityProps) {
  const { t } = useTranslation(["formatter"]);

  let formattedCarbon = "-";
  if (value) {
    formattedCarbon = formatCarbon(t, value, TCarbonUnit.tCO2e).formattedCarbon;
  }

  return (
    <div className="gap-y-2xs border-grayscale-xx-light p-sm flex flex-col rounded-md border border-solid text-sm">
      <Typography
        step="-1"
        weight="semibold"
        as="h4"
        className="text-grayscale"
      >
        {title}
      </Typography>
      <div className="gap-2xs flex items-end lg:flex-col lg:items-center">
        <Typography step="4" weight="semibold">
          {formattedCarbon}
        </Typography>
        <Typography
          step={value ? "0" : "-1"}
          className={cn("pb-3xs lg:pb-0", !value && "text-grayscale")}
        >
          {value ? unit : emptyValueMessage}
        </Typography>
      </div>
    </div>
  );
}

export default CarbonIntensity;
